export default __webpack_public_path__ + "static/media/objects-intuition-introversion.8b834ff6.png";